"use client";

import { useEffect, useState } from "react";
import { ForumSessionUser, getForumToken, getForumUser } from "./PublicAuth";
import { authedFetch } from "./PublicEngage";

// Who is this browser on the floor? The stored session only knows name and
// avatar; moderator status comes from the backend's eligibility check (same
// endpoint the CRM tab uses) and is cached per token for ten minutes.
export interface ForumRole {
  user: ForumSessionUser | null;
  isModerator: boolean;
  canWrite: boolean;
  loading: boolean;
}

const KEY = "ic-forum-role";
const TTL = 10 * 60_000;

export function useForumRole(): ForumRole {
  const [role, setRole] = useState<ForumRole>({ user: null, isModerator: false, canWrite: false, loading: true });

  useEffect(() => {
    let cancelled = false;
    const user = getForumUser();
    const token = getForumToken();
    if (!user || !token) {
      setRole({ user: null, isModerator: false, canWrite: false, loading: false });
      return;
    }
    const tokenKey = token.slice(-24);
    try {
      const cached = JSON.parse(sessionStorage.getItem(KEY) || "null");
      if (cached && cached.tokenKey === tokenKey && Date.now() - cached.at < TTL) {
        setRole({ user, isModerator: !!cached.isModerator, canWrite: !!cached.canWrite, loading: false });
        return;
      }
    } catch {
      // ignore
    }
    (async () => {
      try {
        const e = await authedFetch("/eligibility");
        const next = { isModerator: !!e?.isModerator, canWrite: !!e?.canWrite };
        try {
          sessionStorage.setItem(KEY, JSON.stringify({ ...next, tokenKey, at: Date.now() }));
        } catch {
          // ignore
        }
        if (!cancelled) setRole({ user, ...next, loading: false });
      } catch {
        if (!cancelled) setRole({ user, isModerator: false, canWrite: false, loading: false });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return role;
}
